module.exports = __webpack_public_path__ + "static/media/login.39e06c65.jpg";